module.exports = __webpack_public_path__ + "img/label-promo.a0414591.png";